import { useEffect, useState } from "react";
import { FormProps } from "../../components/form/interface/formInterface";
import SmallForm from "../../components/form/small_form";
import DivStyle from "../../components/style/div.component";
import GameForm from "../../components/form/game_form";
import GAMEAPI from "../../api/game";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { UserState } from "../../recoil/user.atom";
import API from "../../api/api";
import { loadingState } from "../../recoil/loading.atom";
import { IJoinSetting } from "../../components/gameSetting/interface/interface";
import { IUser } from "../../pages/user/interface/interface";

const ManualGpPayment = () => {
  const mode = "S";
  const [frNickName, setfrNickName] = useState("");
  const [frUser, setFrUser] = useState<IUser | null>(null);
  const [frGameMoney, setfrGameMoney] = useState("");
  const [frRebuy, setfrRebuy] = useState("");
  const [memo, setMemo] = useState("");
  const user: any | IUser = useRecoilValue(UserState);
  const setIsLoading = useSetRecoilState(loadingState);
  const search = async () => {
    const res = await API.findByNickName(frNickName);
    if (res && res.status === 200) {
      if (res.data.code === 4007) {
        alert(res.data.message);
      } else {
        if (!res.data.validate) {
          alert("본인인증하지 않은 유저입니다.");
        } else {
          if (
            window.confirm("추천하실 수 있는 사용자 입니다. 추천 하시겠습니까?")
          ) {
            setFrUser(res.data);
          }
        }
      }
    }
  };

  const send = async () => {
    if (!frUser) {
      alert("추천할 친구를 선택해주세요.");
      return;
    }

    if (!memo) {
      alert("메모를 입력해 주세요.");
      return;
    }

    if (memo === "") {
      alert("메모를 입력해 주세요.");
      return;
    }

    const body = {
      userId: user.id,
      userNickname: user.nickname,
      friendId: frUser.id,
      friendNickname: frUser.nickname,
      rebuy: frRebuy,
      gameMoney: frGameMoney,
    };
    setIsLoading(true);
    const res = await API.registerFriendRecommend(body);
    if (res && res.status === 200) {
      if (res.data.code === 200) {
        const addRecommendBody = {
          token: frUser.accessToken,
          point: frGameMoney,
          rebuyinTicket: frRebuy,
          password: "qlrnqofiwjdo1932938@#@#1",
          memo,
        };
        const addPointRes = await GAMEAPI.addPointRebuyin(addRecommendBody);
        if (addPointRes && addPointRes.status === 200) {
          if (addPointRes.data.result === 1) {
            alert("수동 추천에 성공 했습니다.");
          } else {
            await API.removeFriendRecommend(body);
            alert("수동 추천에 실패했습니다.");
          }
        }
      } else if (res.data.code === 6001) {
        alert(res.data.message);
      } else {
        alert("수동 추천에 실패했습니다.");
      }
    }
    setIsLoading(false);

    setfrNickName("");
    setfrRebuy("");
    setFrUser(null);
    setfrGameMoney("");
    setMemo("");
  };

  const formData2: FormProps = {
    title: "친구 보상 수동 출금",
    form: [
      {
        value: { value1: frNickName, search: search },
        setValue: setfrNickName,
        label: "닉네임",
        type: "search-form",
        width: "100%",
      },
      {
        value: frGameMoney,
        setValue: setfrGameMoney,
        label: "게임 머니",
        type: "input",
        width: "100%",
      },
      {
        value: frRebuy,
        setValue: setfrRebuy,
        label: "리바인",
        type: "input",
        width: "100%",
      },
      {
        value: memo,
        setValue: setMemo,
        label: "메모",
        type: "input",
        width: "100%",
      },
    ],
  };
  return (
    <DivStyle
      width="100%"
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      justify_content="center"
      setMobile={true}
    >
      <DivStyle width="33%" height="500px" marginTop="100px">
        <SmallForm
          form={formData2.form}
          title={formData2.title}
          save={send}
          mode={mode}
        />
      </DivStyle>
    </DivStyle>
  );
};

export default ManualGpPayment;
